import { ParagraphSmallHeavy } from 'styles/elements/typography';
import {
  ButtonWrapper,
  ConfirmationModalWrapper,
  MessagingModalConfirmButton,
  RevertButton,
  StyledConfirmationModal,
} from './styles';

interface MessagingConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  questionText: string;
  confirmText: string;
  cancelText: string;
  idPrefix: string;
  dataAutomation?: string;
}

export const MessagingConfirmationModal = (props: MessagingConfirmationModalProps) => {
  const { isOpen, onClose, onConfirm, onCancel, questionText, confirmText, cancelText, idPrefix, dataAutomation } =
    props;
  return (
    <StyledConfirmationModal
      open={isOpen}
      onClose={onClose}
      aria-labelledby={`${idPrefix}-modal`}
      aria-describedby={`${idPrefix}-modal`}
      id={`${idPrefix}-modal`}
      data-automation={dataAutomation || 'confirmationModal'}
    >
      <ConfirmationModalWrapper>
        <ParagraphSmallHeavy>{questionText}</ParagraphSmallHeavy>
        <ButtonWrapper>
          <RevertButton data-automation="confirmationModalRevertBtn" onClick={onCancel}>
            {cancelText}
          </RevertButton>
          <MessagingModalConfirmButton data-automation="confirmationModalConfirmBtn" onClick={onConfirm}>
            {confirmText}
          </MessagingModalConfirmButton>
        </ButtonWrapper>
      </ConfirmationModalWrapper>
    </StyledConfirmationModal>
  );
};
